/** Prefix for bucket-raffle ticket barcodes (CODE128-friendly). */
export const RAFFLE_TICKET_BARCODE_PREFIX = 'FMFLY:';

export function buildRaffleTicketBarcodePayload(flyerId) {
  if (flyerId == null || String(flyerId).trim() === '') return '';
  return `${RAFFLE_TICKET_BARCODE_PREFIX}${String(flyerId).trim()}`;
}

/** Value encoded on printed raffle tickets (flyer id only; shorter CODE128 than FMFLY: prefix). */
export function buildRaffleTicketPrintBarcodeValue(flyerId) {
  if (flyerId == null || String(flyerId).trim() === '') return '';
  return String(flyerId).trim();
}

/**
 * Parse keyboard-wedge scan: "FMFLY:<id>" or raw flyer id fallback.
 * @param {string} raw
 * @returns {string|null} flyer document id
 */
export function parseRaffleTicketBarcodeScan(raw) {
  const t = String(raw || '')
    .trim()
    .replace(/\r|\n/g, '');
  if (!t) return null;
  if (t.startsWith(RAFFLE_TICKET_BARCODE_PREFIX)) {
    const id = t.slice(RAFFLE_TICKET_BARCODE_PREFIX.length).trim();
    return id || null;
  }
  return t;
}

/**
 * When a wedge scanner adds leading/trailing junk, map the scan to a known flyer id.
 * Tries exact match, then drops up to `maxTrim` characters from the start, then from the end.
 * @param {string} scanned
 * @param {Set<string>} validIds
 * @param {number} [maxTrim=4]
 * @returns {string|null} matching id from validIds
 */
export function resolveFlyerIdFromNoisyScan(scanned, validIds, maxTrim = 4) {
  const s = String(scanned || '').trim();
  if (!s || !validIds || validIds.size === 0) return null;
  if (validIds.has(s)) return s;
  let n = Math.floor(Number(maxTrim));
  if (!Number.isFinite(n)) n = 4;
  n = Math.max(0, Math.min(12, n));
  for (let a = 1; a <= n; a += 1) {
    const t = s.slice(a);
    if (t && validIds.has(t)) return t;
  }
  for (let b = 1; b <= n; b += 1) {
    const t = s.slice(0, -b);
    if (t && validIds.has(t)) return t;
  }
  return null;
}
